<template>
  <Teleport to="body">
    <div
      class="ios-upgrade-overlay"
      role="dialog"
      aria-modal="true"
      aria-live="polite"
      @touchmove.prevent
      @wheel.prevent
    >
      <p class="ios-upgrade-overlay__text">{{ t('common.iosUpgradeHint') }}</p>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const { t } = useI18n()
const locked = ref(true)

useBodyScrollLock(locked)

onMounted(() => {
  window.scrollTo(0, 0)
})
</script>

<style scoped lang="scss">
.ios-upgrade-overlay {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 98;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: var(--bg-color, #182134);
  touch-action: none;
  overscroll-behavior: none;
}

.ios-upgrade-overlay__text {
  margin: 0;
  max-width: 320px;
  text-align: center;
  font-size: 16px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.92);
}
</style>
